export default {
  'how_it_works.title': 'Comment ça marche',
  'how_it_works.subtitle': 'Simple, sécurisé et discret',
  'how_it_works.for_clients': 'Pour les Clients',
  'how_it_works.for_escorts': 'Pour les Escorts',
  'how_it_works.secure_private': 'Sécurisé et Privé',
  'how_it_works.verified_profiles': 'Profils Vérifiés',
  'how_it_works.secure_payments': 'Paiements Sécurisés',
  
  // For clients section
  'how_it_works.browse_profiles': 'Parcourir les profils',
  'how_it_works.browse_profiles_desc': 'Explorez une sélection d\'escortes vérifiées.',
  'how_it_works.subscribe': 'Abonnez-vous (Optionnel)',
  'how_it_works.subscribe_desc': 'Débloquez le contenu exclusif et les coordonnées.',
  'how_it_works.connect': 'Connectez-vous en toute sécurité',
  'how_it_works.connect_desc': 'Utilisez notre messagerie sécurisée pour discuter des détails.',
  'how_it_works.arrange': 'Organisez votre rencontre',
  'how_it_works.arrange_desc': 'Finalisez les détails de votre rendez-vous en toute discrétion.',
  
  // For escorts section
  'how_it_works.create_profile': 'Créez votre profil',
  'how_it_works.create_profile_desc': 'Présentez vos services et votre disponibilité.',
  'how_it_works.get_verified': 'Faites-vous vérifier',
  'how_it_works.get_verified_desc': 'Gagnez en crédibilité et attirez plus de clients.',
  'how_it_works.offer_subscriptions': 'Proposez des abonnements',
  'how_it_works.offer_subscriptions_desc': 'Monétisez votre contenu exclusif et fidélisez vos clients.',
  'how_it_works.manage_bookings': 'Gérez vos réservations',
  'how_it_works.manage_bookings_desc': 'Organisez votre emploi du temps et vos interactions.',
  
  // Feature descriptions
  'how_it_works.secure_private_desc': 'Nous priorisons votre vie privée avec une messagerie cryptée et une gestion discrète des données.',
  'how_it_works.verified_profiles_desc': 'Notre processus de vérification assure l\'authenticité et la sécurité pour tous.',
  'how_it_works.secure_payments_desc': 'Les transactions pour les abonnements sont traitées en toute sécurité via Stripe.',
  
  // FAQ section
  'how_it_works.faq': 'Questions Fréquentes',
  'how_it_works.faq_privacy': 'Comment ma vie privée est-elle protégée ?',
  'how_it_works.faq_privacy_answer': 'Nous utilisons des mesures de sécurité robustes et ne partageons jamais vos informations personnelles.',
  'how_it_works.faq_subscription': 'Dois-je m\'abonner ?',
  'how_it_works.faq_subscription_answer': 'L\'abonnement est optionnel pour les clients mais débloque des fonctionnalités comme la messagerie et le contenu exclusif.',
  'how_it_works.faq_verification': 'La vérification est-elle obligatoire ?',
  'how_it_works.faq_verification_answer': 'La vérification est fortement recommandée pour les escortes afin d\'établir la confiance, et peut être requise pour certaines fonctionnalités client.',
  
  // Call to action
  'how_it_works.ready': 'Prêt à commencer ?',
  'how_it_works.join_today': 'Rejoignez Pink Paradise dès aujourd\'hui.',
  'how_it_works.create_account': 'Créer un compte',
  'how_it_works.explore_profiles': 'Explorer les profils',
};
